// extracted by mini-css-extract-plugin
module.exports = {"protocol-fr":"qLx9Dhx+rl9T3rkoFzwTIg=="};